module.exports = __webpack_public_path__ + "static/media/edit.70b9d478.svg";